// extracted by mini-css-extract-plugin
module.exports = {"blogPosts":"Product_blogPosts__2_QwY"};